import CostSharing from "./CostSharing";
import { SLOT_NAMES } from "../../../utils/constants";

const step = 15
const StepFifteen = ({ activeStep, control, errors, setValue, getValues }) => {
    if (activeStep !== step) return;

    const template = getValues("template")
    const baseName = 'costShareBenefitDetails.specialServices';
    const services = [
        {
            title: 'Cellular Gene Therapy',
            name: `${baseName}.cellularGeneTherapy.type`,
            inNetworkName: `${baseName}.cellularGeneTherapy.inNetwork`,
            outOfNetworkName: `${baseName}.cellularGeneTherapy.outOfNetwork`,
            category: SLOT_NAMES.CELLULAR_GENE_THERAPY
        },
        {
            title: 'Genetic Testing / Counseling',
            name: `${baseName}.geneticTestingOrCounseling.type`,
            inNetworkName: `${baseName}.geneticTestingOrCounseling.inNetwork`,
            outOfNetworkName: `${baseName}.geneticTestingOrCounseling.outOfNetwork`,
            category: SLOT_NAMES.GENETIC_TESTING
        },
        {
            title: 'Gastric Bypass / Bariatric',
            name: `${baseName}.gastricBypass.type`,
            inNetworkName: `${baseName}.gastricBypass.inNetwork`,
            outOfNetworkName: `${baseName}.gastricBypass.outOfNetwork`,
            category: SLOT_NAMES.GASTRIC_BYPASS_BARIATRIC
        },
        {
            title: 'Gender Affirming Medical & Surgical Treatment',
            name: `${baseName}.genderAffirming.type`,
            inNetworkName: `${baseName}.genderAffirming.inNetwork`,
            outOfNetworkName: `${baseName}.genderAffirming.outOfNetwork`,
            category: SLOT_NAMES.GENDER_AFFIRMATION
        },
        {
            title: 'Transplant',
            name: `${baseName}.transplantTravel.type`,
            inNetworkName: `${baseName}.transplantTravel.inNetwork`,
            outOfNetworkName: `${baseName}.transplantTravel.outOfNetwork`,
            category: SLOT_NAMES.TRANSPLANTS
        },
        {
            title: 'Dental Accident',
            name: `${baseName}.impactedTeeth.type`,
            inNetworkName: `${baseName}.impactedTeeth.inNetwork`,
            outOfNetworkName: `${baseName}.impactedTeeth.outOfNetwork`,
            category: SLOT_NAMES.DENTAL_ACCIDENTAL
        },
        {
            title: 'Sleep Study',
            name: `${baseName}.sleepStudy.type`,
            inNetworkName: `${baseName}.sleepStudy.inNetwork`,
            outOfNetworkName: `${baseName}.sleepStudy.outOfNetwork`,
            category: SLOT_NAMES.SLEEP_STUDIES
        },
        {
            title: 'Hearing Aids',
            name: `${baseName}.hearingAids.type`,
            inNetworkName: `${baseName}.hearingAids.inNetwork`,
            outOfNetworkName: `${baseName}.hearingAids.outOfNetwork`,
            category: SLOT_NAMES.HEARING_AIDS
        },
        {
            title: 'Vision Services',
            name: `${baseName}.visionServices.type`,
            inNetworkName: `${baseName}.visionServices.inNetwork`,
            outOfNetworkName: `${baseName}.visionServices.outOfNetwork`,
            category: SLOT_NAMES.VISION_SERVICES
        },
    ].sort((a, b) => a.title?.localeCompare(b.title))

    return (
        <>
            {services?.map(serv => {
                return <div className="cost-sharing-box" key={serv.title}>
                    <CostSharing
                        name={serv.name}
                        title={serv.title}
                        category={serv.category}
                        searchText={serv.searchText}
                        filterText={serv.filterText}
                        template={template}
                        inNetworkName={serv.inNetworkName}
                        outOfNetworkName={serv.outOfNetworkName}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                    />
                </div>
            })}
        </>
    )
}

export default StepFifteen
